export const RESET_PASSWORD_PATH = "/reset-password";
export const RESET_PASSWORD_PAGE = "reset-password";
